// src/components/common/Layout/Layout.jsx
import React from 'react';

const Layout = () => {
  const styles = {
    section: {
      backgroundColor: '#f8f9fa',
      padding: '4rem 0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif'
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      textAlign: 'left'
    },
    title: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#1a1a1a',
      margin: '0 0 2rem 0',
      lineHeight: '1.2',
      letterSpacing: '-0.02em'
    },
    content: {
      fontSize: '1.1rem',
      color: '#6b7280',
      lineHeight: '1.7',
      margin: '0'
    }
  };

  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          .layout-container {
            padding: 0 1.5rem !important;
          }
          .layout-title {
            font-size: 2.5rem !important;
          }
        }
        
        @media (max-width: 768px) {
          .layout-container {
            padding: 0 1rem !important;
          }
          .layout-title {
            font-size: 2.2rem !important;
          }
          .layout-content {
            font-size: 1rem !important;
          }
        }
        
        @media (max-width: 640px) {
          .layout-title {
            font-size: 2rem !important;
          }
        }
      `}</style>
      
      <section style={styles.section}>
        <div style={styles.container} className="layout-container">
          <h2 style={styles.title} className="layout-title">
            Build Your Wealth Systematically
          </h2>
          <div style={styles.content} className="layout-content">
            <p style={{margin: 0}}>
              Building long-term wealth requires discipline and systematic planning, and results may vary for each individual. At WinNest, our NISM certified distributors help you select suitable mutual fund schemes aligned with your goals. We assist in creating a systematic investment plan for your objectives, factoring in market risks and regulatory guidelines.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Layout;